import React from 'react';

import { FormControlLabel, Stack, Switch, Tooltip, Typography } from '@mui/material';

const HELPER_COPY =
  'By default, new promo clones are limited to the usage limit of the parent promo (including sibling clones). Emancipating a promo code will remove this limit, allowing it to be used independently of the parent/siblings usage.';

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  plural?: boolean;
  /** Switch + label only; full explanation in a tooltip (matches other bulk-form columns). */
  compactHelper?: boolean;
};

/** Shared copy for bulk clone and bulk create (random-suffix) flows. */
export default function PromoEmancipateClonedPromosOption({
  checked,
  onChange,
  disabled,
  plural = false,
  compactHelper = false,
}: Props) {
  const label = plural ? 'Emancipate cloned promos' : 'Emancipate cloned promo';
  const control = (
    <FormControlLabel
      control={<Switch checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />}
      label={label}
    />
  );

  if (compactHelper) {
    return (
      <Tooltip title={HELPER_COPY} placement="top" arrow enterTouchDelay={300}>
        {control}
      </Tooltip>
    );
  }

  return (
    <Stack spacing={0.5} sx={{ alignItems: 'flex-start' }}>
      {control}
      <Typography variant="body2" color="text.secondary" sx={{ pl: { xs: 0, sm: 4.5 }, maxWidth: '100%' }}>
        {HELPER_COPY}
      </Typography>
    </Stack>
  );
}
